import {
  model,
  Model,
  prop,
  _async,
  _await,
  idProp,
  registerRootStore,
  modelAction,
  modelFlow,
  Frozen,
  frozen,
  rootRef,
  detach,
  findParent,
  getSnapshot,
} from "mobx-keystone";
import { computed, observable } from "mobx";

export type BobEventKind =
  | "platform-alert"
  | "invoice-created"
  | "invoice-paid"
  | "payattempt-started"
  | "payattempt-succeeded"
  | "onchain-address-created"
  | "onchain-payment-sent"
  | "onchain-payment-received"
  | "usdt-payment-sent"
  | "hold-invoice-accepted";

@model("exrails/BobEvent")
export class BobEvent extends Model({
  _version: prop(0),
  createdAtTimestamp: prop<number>(() => Date.now()),
  id: idProp,
  message: prop<string>(""),
  kind: prop<BobEventKind>("platform-alert"), // info, alert, error
  title: prop<string>(""),
  payRequest: prop<string | null>(null),
  uuid: prop<string | null>(null),
}) {
  @computed
  get foo() {
    return "bar";
  }
}

export interface BobEventInterface {
  Event: BobEvent;
}
